import { render, staticRenderFns } from "./PH26V.vue?vue&type=template&id=56924f4f&scoped=true"
import script from "./PH26V.vue?vue&type=script&lang=js"
export * from "./PH26V.vue?vue&type=script&lang=js"
import style0 from "./PH26V.vue?vue&type=style&index=0&id=56924f4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56924f4f",
  null
  
)

export default component.exports